export default "__VITE_ASSET__B83Pj4E7__"